import { STATUS_LABELS, STATUS_COLORS, PRIORITY_COLORS, PRIORITY_LABELS } from '../utils/constants';

const EXTENDED_STATUS_COLORS = {
  escalated:                { bg: '#EEEDFE', color: '#534AB7' },
  dept_action_pending:      { bg: '#FAEEDA', color: '#854F0B' },
  dept_confirmed:           { bg: '#EAF3DE', color: '#3B6D11' },
  pending_customer_contact: { bg: '#FEF3CD', color: '#856404' },
  reopened:                 { bg: '#FCEBEB', color: '#A32D2D' },
  closed:                   { bg: '#EAF3DE', color: '#3B6D11' },
  pending_3rd_party:        { bg: '#FAEEDA', color: '#854F0B' },
  pending_finance:          { bg: '#FEF3CD', color: '#92400E' },
  under_process:            { bg: '#EFF6FF', color: '#1D4ED8' },
  resolved:                 { bg: '#ECFDF5', color: '#065F46' },
};

export function StatusBadge({ status }) {
  const extended = EXTENDED_STATUS_COLORS[status];
  if (extended) {
    return (
      <span
        style={{ backgroundColor: extended.bg, color: extended.color }}
        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
      >
        {STATUS_LABELS[status] || status?.replace(/_/g, ' ')}
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${STATUS_COLORS[status] || 'bg-gray-100 text-gray-700'}`}>
      {STATUS_LABELS[status] || status?.replace(/_/g, ' ')}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${PRIORITY_COLORS[priority] || 'bg-gray-100 text-gray-600'}`}>
      {PRIORITY_LABELS[priority] || priority}
    </span>
  );
}
